import { Outlet } from "react-router-dom";
import Footer from "components/partials/footer/Footer";
import { Header } from "components/partials/header/Header";
import WhatsApp from "components/common/WhatsApp";

export const Layout = () => {
    return (
        <>
            <Header />
            <main className="min-h-screen">
                <Outlet />
            </main>
            <Footer />
            <WhatsApp />
        </>
    );
};
